import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';
import PN from "persian-number";



const DayReportIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const [List, setList] = useState([]);
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));
    const [BeginDate, setBeginDate] = useState(moment(new Date()).add("Day", -7));
    const [EndDate, setEndDate] = useState(moment(new Date()));
    const [RegisterBeginDate, setRegisterBeginDate] = useState(moment(new Date()).add("Day", -7));
    const [RegisterEndDate, setRegisterEndDate] = useState(moment(new Date()));
    const [loading, setLoading] = React.useState(false)

    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState()
    const CompactCell = props => <rsuite.Table.Cell {...props} style={{ padding: 4 }} />;
    const CompactHeaderCell = props => <rsuite.Table.HeaderCell {...props} style={{ padding: 4 }} />;
    const defaultColumns = [
        {
            key: 'row',
            label: '#',
            fixed: true,
            sortable: true,
            width: 50
        },

        {
            key: 'CreateDate',
            label: 'تاریخ ثبت سیستمی',
            fullText: true,
            sortable: true,
            fixed: true,
            flexGrow: 2

        },
        {
            key: 'RegisterDate',
            label: 'تاریخ سند',
            fullText: true,
            sortable: true,
            fixed: true,
            flexGrow: 2
        },
        {
            key: 'SystemNumber',
            label: 'شماره سند',
            fixed: true,
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 1
        },
        {
            key: 'Number',
            label: 'عطف سند',
            fixed: true,
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 1
        },
        {
            key: 'SerialNo',
            label: 'سریال',
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 1
        },


        {
            key: 'ACCC',
            label: 'حساب ',
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 3
        },

        // {
        //     key: 'Sub',
        //     label: 'حساب تفصیلی',
        //     fullText: true,
        //     resizable: true,
        //     sortable: true,
        //     flexGrow: 3
        // },
        {
            key: 'Comment',
            label: ' توضیحات',
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 4
        }
        ,
        {
            key: 'CreditComment',
            label: 'بستانکار (ریال)',
            fullText: true,
            resizable: true,
            sortable: true,
            className: 'text-success',
            flexGrow: 2
        },
        {
            key: 'DebitComment',
            label: 'بدهکار (ریال)',
            fullText: true,
            resizable: true,
            sortable: true,
            className: 'text-danger',
            flexGrow: 2
        },


    ];

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };
    const handleChangeLimit = dataKey => {
        setPage(1);
        setLimit(dataKey);
    };


    const [compact, setCompact] = React.useState(true);
    const [columnKeys, setColumnKeys] = React.useState(defaultColumns.map(column => column.key));

    const columns = defaultColumns.filter(column => columnKeys.some(key => key === column.key));
    const CustomCell = compact ? CompactCell : rsuite.Table.Cell;
    const CustomHeaderCell = compact ? CompactHeaderCell : rsuite.Table.HeaderCell;
    const [limit, setLimit] = React.useState(10);
    const [page, setPage] = React.useState(1);


    //#endregion





    const BeginDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setBeginDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const EndDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setEndDate(moment(m, 'jYYYY/jMM/jDD'));
    }


    const RegisterBeginDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setRegisterBeginDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const RegisterEndDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setRegisterEndDate(moment(m, 'jYYYY/jMM/jDD'));
    }


    //#region Methods


    const Search = () => {
        alert(RegisterEndDate)
        var RequestOptions = {
            data: {
                'FiscalYearId': FiscalYearId * 1,

            },
            url: General.ApiRoute() + "/Account_Doc/DayReport",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'BeginDate': BeginDate != null ? moment(BeginDate.format()).format("jYYYY/jMM/jDD") : "",
                'EndDate': EndDate != null ? moment(EndDate.format()).format("jYYYY/jMM/jDD") : "",
                'RegisterBeginDate': RegisterBeginDate != null ? moment(RegisterBeginDate.format()).format("jYYYY/jMM/jDD") : "",
                'RegisterEndDate': RegisterEndDate != null ? moment(RegisterEndDate.format()).format("jYYYY/jMM/jDD") : "",
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    var tmp = []
                    console.dir(result.data)
                    console.dir(result.data.length)
                    for (var i = 0; i < result.data.length; i++) {
                        tmp.push({
                            row: i + 1,
                            Number: result.data[i].number,
                            RegisterDate: result.data[i].registerDate,
                            CreateDate: result.data[i].createDate,
                            SerialNo: result.data[i].serialNo,
                            SystemNumber: result.data[i].systemNumber,
                            Comment: result.data[i].comment,
                            TotalPrice: PN.sliceNumber(result.data[i].totalPrice),
                            DebitComment: PN.sliceNumber(result.data[i].debitPrice),
                            CreditComment: PN.sliceNumber(result.data[i].creditPrice),
                            RemainComment: result.data[i].acc_CRemain > 0 ? PN.sliceNumber(result.data[i].acc_CRemain) + " بس" : result.data[i].acc_CRemain < 0 ? PN.sliceNumber(result.data[i].acc_CRemain * (-1)) + " بد" : "تسویه",
                            Acc_CTitle: result.data[i].acc_CTitle,
                            Acc_CCode: result.data[i].acc_CCode,
                            DebitPrice: result.data[i].debitPrice,
                            CreditPrice: result.data[i].creditPrice,
                            Acc_CRemain: result.data[i].acc_CRemain,
                            ACCC: result.data[i].acc_CTitle + " [" + result.data[i].acc_CCode + "]|" + result.data[i].sub_Acc_LTitle1,

                        })
                    }
                    setList(tmp)
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }





    // const Print = (id) => {
    //     navigate("/PrintDoc")
    //     localStorage.setItem("BackPage", "Doc");
    //     localStorage.setItem("DocHeaderId", id)
    // }




    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 37);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        Search();
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    const handelKeyDown = (e, row) => {
        if (e.key == "Enter") {
            Search();
        }


    }

    useEffect(() => {
        CheckPermission();
        document.title = "دفتر روزانه";
        const inputElement = document.querySelector('.FocusItem');
        if (inputElement) {
            inputElement.focus();
        }
    }, [])
    //#endregion







    return (

        <Layout title=" دفتر روزانه">


            <div className="h-100 p-1 " onKeyDown={handelKeyDown} >
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Search}>  جستجو</rsuite.Button>

                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> از تاریخ ثبت </label>
                            <rsuite.InputGroup>
                                <rsuite.Button color="red" onClick={() => setBeginDate(null)} appearance="subtle" className='border border-danger'>
                                    <BiIcon.BiX size={15}></BiIcon.BiX>
                                </rsuite.Button>
                                <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={BeginDate} onChange={BeginDate_Change} />
                            </rsuite.InputGroup>
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>تا تاریخ ثبت </label>
                            <rsuite.InputGroup>
                                <rsuite.Button color="red" onClick={() => setEndDate(null)} appearance="subtle" className='border border-danger'>
                                    <BiIcon.BiX size={15}></BiIcon.BiX>
                                </rsuite.Button>
                                <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={EndDate} onChange={EndDate_Change} />

                            </rsuite.InputGroup>

                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> از تاریخ سند </label>
                            <rsuite.InputGroup>
                                <rsuite.Button color="red" onClick={() => setRegisterBeginDate(null)} appearance="subtle" className='border border-danger'>
                                    <BiIcon.BiX size={15}></BiIcon.BiX>
                                </rsuite.Button>
                                <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={RegisterBeginDate} onChange={RegisterBeginDate_Change} />
                            </rsuite.InputGroup>
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>تا تاریخ سند </label>
                            <rsuite.InputGroup>
                                <rsuite.Button color="red" onClick={() => setRegisterEndDate(null)} appearance="subtle" className='border border-danger'>
                                    <BiIcon.BiX size={15}></BiIcon.BiX>
                                </rsuite.Button>
                                <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={RegisterEndDate} onChange={RegisterEndDate_Change} />

                            </rsuite.InputGroup>

                        </rsuite.Col>
                    </rsuite.Row>
                    <rsuite.Row>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <label> فیلتر   </label>
                            <rsuite.VStack spacing={16}>

                                <rsuite.TagPicker
                                    data={defaultColumns}
                                    labelKey="label"
                                    valueKey="key"
                                    value={columnKeys}
                                    onChange={setColumnKeys}
                                    cleanable={false}
                                    className='Font10 w-100p '
                                />
                            </rsuite.VStack>
                        </rsuite.Col>
                    </rsuite.Row>


                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table

                                    minHeight={450}
                                    rowHeight={80}
                                    loading={loading}

                                    data={List.sort((a, b) => {
                                        let x = a[sortColumn];
                                        let y = b[sortColumn];
                                        if (typeof x === 'string') {
                                            x = x.charCodeAt();
                                        }
                                        if (typeof y === 'string') {
                                            y = y.charCodeAt();
                                        }
                                        if (sortType === 'asc') {
                                            return x - y;
                                        } else {
                                            return y - x;
                                        }
                                    }).filter((v, i) => {
                                        const start = limit * (page - 1);
                                        const end = start + limit;
                                        return i >= start && i < end;
                                    })}
                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={handleSortColumn}


                                >
                                    {columns.map(column => {

                                        const { key, label, className, ...rest } = column;
                                        {


                                            return (
                                                <rsuite.Table.Column {...rest} key={key}>
                                                    <CustomHeaderCell>{label}</CustomHeaderCell>
                                                    <rsuite.Table.Cell {...rest} dataKey={key}>
                                                        {rowData => {
                                                            let dynamicClass = "";

                                                            if (key === "CreditComment") {
                                                                dynamicClass = "text-success";
                                                            } else if (key === "DebitComment") {
                                                                dynamicClass = "text-danger";
                                                            }
                                                            const lines = String(rowData?.[key]).split("|");

                                                            return <span className={`${className || ""} ${dynamicClass}`}>
                                                                {/* {rowData[key]} */}
                                                                {lines.map((line, idx) => (
                                                                    <div key={idx}>{line.trim()}</div>
                                                                ))}
                                                            </span>;
                                                        }}
                                                    </rsuite.Table.Cell>
                                                </rsuite.Table.Column>
                                            );
                                        }
                                    })}


                                </rsuite.Table>

                                <div style={{ paddingTop: 20 }}>
                                    <rsuite.Pagination
                                        prev
                                        next
                                        first
                                        last
                                        ellipsis
                                        boundaryLinks
                                        maxButtons={5}
                                        size="xs"
                                        layout={['total', '-', 'limit', '|', 'pager', 'skip']}
                                        total={List.length}
                                        limitOptions={[5, 10, 30, 50, 100]}
                                        limit={limit}
                                        activePage={page}
                                        onChangePage={setPage}
                                        onChangeLimit={handleChangeLimit}
                                    />
                                </div>
                                {/* <div className="rs-table-row rs-table-row-summary">
                                    <div className="rs-table-cell">جمع کل</div>
                                    <div className="rs-table-cell">{List.reduce((s, r) => s + r.creditPrice, 0)}</div>
                                </div> */}



                            </rsuite.Panel>

                        </div>
                    </div >
                    <rsuite.Row>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Divider></rsuite.Divider>
                            <small><b> Enter :</b> جستجو </small>
                        </rsuite.Col>
                    </rsuite.Row>

                </rsuite.Panel >
            </div >


        </Layout >


    )
}

export default DayReportIndex;